"use client";

import { c as _c } from "react/compiler-runtime";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import type React from "react";
export function useDialogContentAnimation(isExiting, internalRef, onExitComplete) {
  const $ = _c(7);
  let t0;
  if ($[0] !== internalRef || $[1] !== isExiting || $[2] !== onExitComplete) {
    t0 = () => {
      if (!internalRef.current) {
        return;
      }
      if (isExiting) {
        gsap.to(internalRef.current, {
          opacity: 0,
          marginTop: 10,
          duration: 0.15,
          ease: "power3.in"
        });
        gsap.delayedCall(0.5, onExitComplete);
      } else {
        gsap.fromTo(internalRef.current, {
          opacity: 0,
          marginTop: 20
        }, {
          opacity: 1,
          marginTop: 0,
          duration: 0.4,
          ease: "power3.out"
        });
      }
    };
    $[0] = internalRef;
    $[1] = isExiting;
    $[2] = onExitComplete;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== isExiting || $[5] !== onExitComplete) {
    t1 = [isExiting, onExitComplete];
    $[4] = isExiting;
    $[5] = onExitComplete;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  useGSAP(t0, t1);
}